import React from 'react'
import { useQueryClient } from 'react-query'

import { ReactivateButton } from 'components/configurations/common/ReactivateButton'
import useAuth from 'hooks/use-auth'
import { agentsQueryKeys } from 'queries/agents/query-keys'
import { usePutClientsActivate } from 'queries/clients/use-put-clients-activate'
import { usePostFailureFlagsAppsUnprotect } from 'queries/failure-flags/use-post-failure-flags-apps-unprotect'
import { type Agent, AgentType } from 'types/api/agents/agents'

export const ReactivateAgentButton: React.FC<{
  agent: Agent
  onSuccess?: () => void
}> = ({ agent, onSuccess }) => {
  const { currentTeamId: teamId } = useAuth()
  const queryClient = useQueryClient()

  const { id, type } = agent

  const isInfrastructureAgent = type === AgentType.INFRASTRUCTURE

  const mutationHookActivateAgent = isInfrastructureAgent
    ? usePutClientsActivate
    : usePostFailureFlagsAppsUnprotect

  const { mutateAsync: mutateActivateAgent } = mutationHookActivateAgent(id)

  const handleSuccess = async () => {
    if (onSuccess) {
      onSuccess()
    }

    await queryClient.invalidateQueries(agentsQueryKeys.get({ teamId }))
    await queryClient.invalidateQueries(agentsQueryKeys.getSummary({ teamId }))
  }

  return (
    <ReactivateButton
      onConfirmRequest={mutateActivateAgent}
      onSuccess={handleSuccess}
    />
  )
}
